module.exports = __webpack_public_path__ + "static/media/vipio.b29e7908.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/vipio.webp
// module id = 372
// module chunks = 0